import { Component } from '@angular/core';

@Component({
  selector: 'app-layout-container',
  standalone: true,
  templateUrl: './layout-container.component.html',
  styleUrl: './layout-container.component.css'
})
export class LayoutContainerComponent { }
